import { render, staticRenderFns } from "./ConfirmMail.vue?vue&type=template&id=2b778dad&scoped=true&"
import script from "./ConfirmMail.vue?vue&type=script&lang=ts&"
export * from "./ConfirmMail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b778dad",
  null
  
)

export default component.exports